import { d as le } from "./deepmerge-c6c56555.js";
import { i as Ae, t as De, c as Re } from "./lodash-es-9bce7d1a.js";
import { forwardRef as Je, createElement as H, createContext as Qe, useContext as Xe, useImperativeHandle as Ze, useEffect as D, Children as we, useRef as U, useState as er, useCallback as F, useMemo as Ve, useLayoutEffect as rr } from "react";
import { g as nr } from "./@contentful-cca97bae.js";
import { w as I } from "./tiny-warning-b49e0329.js";
import "./hoist-non-react-statics-0f4f9040.js";
var Ne = Array.isArray, _e = Object.keys, tr = Object.prototype.hasOwnProperty, ir = typeof Element < "u";
function se(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    var a = Ne(e), t = Ne(n), i, l, c;
    if (a && t) {
      if (l = e.length, l != n.length)
        return !1;
      for (i = l; i-- !== 0; )
        if (!se(e[i], n[i]))
          return !1;
      return !0;
    }
    if (a != t)
      return !1;
    var p = e instanceof Date, y = n instanceof Date;
    if (p != y)
      return !1;
    if (p && y)
      return e.getTime() == n.getTime();
    var T = e instanceof RegExp, V = n instanceof RegExp;
    if (T != V)
      return !1;
    if (T && V)
      return e.toString() == n.toString();
    var M = _e(e);
    if (l = M.length, l !== _e(n).length)
      return !1;
    for (i = l; i-- !== 0; )
      if (!tr.call(n, M[i]))
        return !1;
    if (ir && e instanceof Element && n instanceof Element)
      return e === n;
    for (i = l; i-- !== 0; )
      if (c = M[i], !(c === "_owner" && e.$$typeof) && !se(e[c], n[c]))
        return !1;
    return !0;
  }
  return e !== e && n !== n;
}
var ar = function(n, a) {
  try {
    return se(n, a);
  } catch (t) {
    if (t.message && t.message.match(/stack|recursion/i) || t.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", t.name, t.message), !1;
    throw t;
  }
};
const P = /* @__PURE__ */ nr(ar);
function E() {
  return E = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var a = arguments[n];
      for (var t in a)
        Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
    }
    return e;
  }, E.apply(this, arguments);
}
function Y(e, n) {
  if (e == null)
    return {};
  var a = {}, t = Object.keys(e), i, l;
  for (l = 0; l < t.length; l++)
    i = t[l], !(n.indexOf(i) >= 0) && (a[i] = e[i]);
  return a;
}
var x = /* @__PURE__ */ Qe(void 0);
x.displayName = "FormikContext";
var or = x.Provider;
x.Consumer;
function Ce() {
  var e = Xe(x);
  return e || (process.env.NODE_ENV !== "production" ? I(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : I(!1)), e;
}
var b = function(n) {
  return typeof n == "function";
}, J = function(n) {
  return n !== null && typeof n == "object";
}, ur = function(n) {
  return String(Math.floor(Number(n))) === n;
}, oe = function(n) {
  return Object.prototype.toString.call(n) === "[object String]";
}, Le = function(n) {
  return we.count(n) === 0;
}, ue = function(n) {
  return J(n) && b(n.then);
};
function lr(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function R(e, n, a, t) {
  t === void 0 && (t = 0);
  for (var i = De(n); e && t < i.length; )
    e = e[i[t++]];
  return t !== i.length && !e || e === void 0 ? a : e;
}
function W(e, n, a) {
  for (var t = Re(e), i = t, l = 0, c = De(n); l < c.length - 1; l++) {
    var p = c[l], y = R(e, c.slice(0, l + 1));
    if (y && (J(y) || Array.isArray(y)))
      i = i[p] = Re(y);
    else {
      var T = c[l + 1];
      i = i[p] = ur(T) && Number(T) >= 0 ? [] : {};
    }
  }
  return (l === 0 ? e : i)[c[l]] === a ? e : (a === void 0 ? delete i[c[l]] : i[c[l]] = a, l === 0 && a === void 0 && delete t[c[l]], t);
}
function Me(e, n, a, t) {
  a === void 0 && (a = /* @__PURE__ */ new WeakMap()), t === void 0 && (t = {});
  for (var i = 0, l = Object.keys(e); i < l.length; i++) {
    var c = l[i], p = e[c];
    J(p) ? a.get(p) || (a.set(p, !0), t[c] = Array.isArray(p) ? [] : {}, Me(p, n, a, t[c])) : t[c] = n;
  }
  return t;
}
function sr(e, n) {
  switch (n.type) {
    case "SET_VALUES":
      return E({}, e, {
        values: n.payload
      });
    case "SET_TOUCHED":
      return E({}, e, {
        touched: n.payload
      });
    case "SET_ERRORS":
      return P(e.errors, n.payload) ? e : E({}, e, {
        errors: n.payload
      });
    case "SET_STATUS":
      return E({}, e, {
        status: n.payload
      });
    case "SET_ISSUBMITTING":
      return E({}, e, {
        isSubmitting: n.payload
      });
    case "SET_ISVALIDATING":
      return E({}, e, {
        isValidating: n.payload
      });
    case "SET_FIELD_VALUE":
      return E({}, e, {
        values: W(e.values, n.payload.field, n.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return E({}, e, {
        touched: W(e.touched, n.payload.field, n.payload.value)
      });
    case "SET_FIELD_ERROR":
      return E({}, e, {
        errors: W(e.errors, n.payload.field, n.payload.value)
      });
    case "RESET_FORM":
      return E({}, e, n.payload);
    case "SET_FORMIK_STATE":
      return n.payload(e);
    case "SUBMIT_ATTEMPT":
      return E({}, e, {
        touched: Me(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return E({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return E({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var B = {}, q = {};
function dr(e) {
  var n = e.validateOnChange, a = n === void 0 ? !0 : n, t = e.validateOnBlur, i = t === void 0 ? !0 : t, l = e.validateOnMount, c = l === void 0 ? !1 : l, p = e.isInitialValid, y = e.enableReinitialize, T = y === void 0 ? !1 : y, V = e.onSubmit, M = Y(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), d = E({
    validateOnChange: a,
    validateOnBlur: i,
    validateOnMount: c,
    onSubmit: V
  }, M), g = U(d.initialValues), w = U(d.initialErrors || B), C = U(d.initialTouched || q), k = U(d.initialStatus), A = U(!1), N = U({});
  process.env.NODE_ENV !== "production" && D(function() {
    typeof p > "u" || (process.env.NODE_ENV !== "production" ? I(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : I(!1));
  }, []), D(function() {
    return A.current = !0, function() {
      A.current = !1;
    };
  }, []);
  var Q = er(0), X = Q[1], K = U({
    values: d.initialValues,
    errors: d.initialErrors || B,
    touched: d.initialTouched || q,
    status: d.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), h = K.current, m = F(function(r) {
    var o = K.current;
    K.current = sr(o, r), o !== K.current && X(function(u) {
      return u + 1;
    });
  }, []), ce = F(function(r, o) {
    return new Promise(function(u, s) {
      var f = d.validate(r, o);
      f == null ? u(B) : ue(f) ? f.then(function(v) {
        u(v || B);
      }, function(v) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", v), s(v);
      }) : u(f);
    });
  }, [d.validate]), Z = F(function(r, o) {
    var u = d.validationSchema, s = b(u) ? u(o) : u, f = o && s.validateAt ? s.validateAt(o, r) : fr(r, s);
    return new Promise(function(v, S) {
      f.then(function() {
        v(B);
      }, function(L) {
        L.name === "ValidationError" ? v(cr(L)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", L), S(L));
      });
    });
  }, [d.validationSchema]), fe = F(function(r, o) {
    return new Promise(function(u) {
      return u(N.current[r].validate(o));
    });
  }, []), ve = F(function(r) {
    var o = Object.keys(N.current).filter(function(s) {
      return b(N.current[s].validate);
    }), u = o.length > 0 ? o.map(function(s) {
      return fe(s, R(r, s));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(u).then(function(s) {
      return s.reduce(function(f, v, S) {
        return v === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || v && (f = W(f, o[S], v)), f;
      }, {});
    });
  }, [fe]), ke = F(function(r) {
    return Promise.all([ve(r), d.validationSchema ? Z(r) : {}, d.validate ? ce(r) : {}]).then(function(o) {
      var u = o[0], s = o[1], f = o[2], v = le.all([u, s, f], {
        arrayMerge: vr
      });
      return v;
    });
  }, [d.validate, d.validationSchema, ve, ce, Z]), O = _(function(r) {
    return r === void 0 && (r = h.values), m({
      type: "SET_ISVALIDATING",
      payload: !0
    }), ke(r).then(function(o) {
      return A.current && (m({
        type: "SET_ISVALIDATING",
        payload: !1
      }), m({
        type: "SET_ERRORS",
        payload: o
      })), o;
    });
  });
  D(function() {
    c && A.current === !0 && P(g.current, d.initialValues) && O(g.current);
  }, [c, O]);
  var $ = F(function(r) {
    var o = r && r.values ? r.values : g.current, u = r && r.errors ? r.errors : w.current ? w.current : d.initialErrors || {}, s = r && r.touched ? r.touched : C.current ? C.current : d.initialTouched || {}, f = r && r.status ? r.status : k.current ? k.current : d.initialStatus;
    g.current = o, w.current = u, C.current = s, k.current = f;
    var v = function() {
      m({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!r && !!r.isSubmitting,
          errors: u,
          touched: s,
          status: f,
          values: o,
          isValidating: !!r && !!r.isValidating,
          submitCount: r && r.submitCount && typeof r.submitCount == "number" ? r.submitCount : 0
        }
      });
    };
    if (d.onReset) {
      var S = d.onReset(h.values, Ie);
      ue(S) ? S.then(v) : v();
    } else
      v();
  }, [d.initialErrors, d.initialStatus, d.initialTouched, d.onReset]);
  D(function() {
    A.current === !0 && !P(g.current, d.initialValues) && T && (g.current = d.initialValues, $(), c && O(g.current));
  }, [T, d.initialValues, $, c, O]), D(function() {
    T && A.current === !0 && !P(w.current, d.initialErrors) && (w.current = d.initialErrors || B, m({
      type: "SET_ERRORS",
      payload: d.initialErrors || B
    }));
  }, [T, d.initialErrors]), D(function() {
    T && A.current === !0 && !P(C.current, d.initialTouched) && (C.current = d.initialTouched || q, m({
      type: "SET_TOUCHED",
      payload: d.initialTouched || q
    }));
  }, [T, d.initialTouched]), D(function() {
    T && A.current === !0 && !P(k.current, d.initialStatus) && (k.current = d.initialStatus, m({
      type: "SET_STATUS",
      payload: d.initialStatus
    }));
  }, [T, d.initialStatus, d.initialTouched]);
  var pe = _(function(r) {
    if (N.current[r] && b(N.current[r].validate)) {
      var o = R(h.values, r), u = N.current[r].validate(o);
      return ue(u) ? (m({
        type: "SET_ISVALIDATING",
        payload: !0
      }), u.then(function(s) {
        return s;
      }).then(function(s) {
        m({
          type: "SET_FIELD_ERROR",
          payload: {
            field: r,
            value: s
          }
        }), m({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (m({
        type: "SET_FIELD_ERROR",
        payload: {
          field: r,
          value: u
        }
      }), Promise.resolve(u));
    } else if (d.validationSchema)
      return m({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Z(h.values, r).then(function(s) {
        return s;
      }).then(function(s) {
        m({
          type: "SET_FIELD_ERROR",
          payload: {
            field: r,
            value: R(s, r)
          }
        }), m({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), Ue = F(function(r, o) {
    var u = o.validate;
    N.current[r] = {
      validate: u
    };
  }, []), Be = F(function(r) {
    delete N.current[r];
  }, []), me = _(function(r, o) {
    m({
      type: "SET_TOUCHED",
      payload: r
    });
    var u = o === void 0 ? i : o;
    return u ? O(h.values) : Promise.resolve();
  }), he = F(function(r) {
    m({
      type: "SET_ERRORS",
      payload: r
    });
  }, []), Ee = _(function(r, o) {
    var u = b(r) ? r(h.values) : r;
    m({
      type: "SET_VALUES",
      payload: u
    });
    var s = o === void 0 ? a : o;
    return s ? O(u) : Promise.resolve();
  }), z = F(function(r, o) {
    m({
      type: "SET_FIELD_ERROR",
      payload: {
        field: r,
        value: o
      }
    });
  }, []), j = _(function(r, o, u) {
    m({
      type: "SET_FIELD_VALUE",
      payload: {
        field: r,
        value: o
      }
    });
    var s = u === void 0 ? a : u;
    return s ? O(W(h.values, r, o)) : Promise.resolve();
  }), ye = F(function(r, o) {
    var u = o, s = r, f;
    if (!oe(r)) {
      r.persist && r.persist();
      var v = r.target ? r.target : r.currentTarget, S = v.type, L = v.name, ie = v.id, ae = v.value, ze = v.checked, qe = v.outerHTML, be = v.options, xe = v.multiple;
      u = o || L || ie, !u && process.env.NODE_ENV !== "production" && Oe({
        htmlContent: qe,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), s = /number|range/.test(S) ? (f = parseFloat(ae), isNaN(f) ? "" : f) : /checkbox/.test(S) ? mr(R(h.values, u), ze, ae) : be && xe ? pr(be) : ae;
    }
    u && j(u, s);
  }, [j, h.values]), ee = _(function(r) {
    if (oe(r))
      return function(o) {
        return ye(o, r);
      };
    ye(r);
  }), G = _(function(r, o, u) {
    o === void 0 && (o = !0), m({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: r,
        value: o
      }
    });
    var s = u === void 0 ? i : u;
    return s ? O(h.values) : Promise.resolve();
  }), Fe = F(function(r, o) {
    r.persist && r.persist();
    var u = r.target, s = u.name, f = u.id, v = u.outerHTML, S = o || s || f;
    !S && process.env.NODE_ENV !== "production" && Oe({
      htmlContent: v,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), G(S, !0);
  }, [G]), re = _(function(r) {
    if (oe(r))
      return function(o) {
        return Fe(o, r);
      };
    Fe(r);
  }), Se = F(function(r) {
    b(r) ? m({
      type: "SET_FORMIK_STATE",
      payload: r
    }) : m({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return r;
      }
    });
  }, []), ge = F(function(r) {
    m({
      type: "SET_STATUS",
      payload: r
    });
  }, []), Te = F(function(r) {
    m({
      type: "SET_ISSUBMITTING",
      payload: r
    });
  }, []), ne = _(function() {
    return m({
      type: "SUBMIT_ATTEMPT"
    }), O().then(function(r) {
      var o = r instanceof Error, u = !o && Object.keys(r).length === 0;
      if (u) {
        var s;
        try {
          if (s = He(), s === void 0)
            return;
        } catch (f) {
          throw f;
        }
        return Promise.resolve(s).then(function(f) {
          return A.current && m({
            type: "SUBMIT_SUCCESS"
          }), f;
        }).catch(function(f) {
          if (A.current)
            throw m({
              type: "SUBMIT_FAILURE"
            }), f;
        });
      } else if (A.current && (m({
        type: "SUBMIT_FAILURE"
      }), o))
        throw r;
    });
  }), Pe = _(function(r) {
    if (r && r.preventDefault && b(r.preventDefault) && r.preventDefault(), r && r.stopPropagation && b(r.stopPropagation) && r.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var o = lr();
      o !== null && o instanceof HTMLButtonElement && (o.attributes && o.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? I(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : I(!1)));
    }
    ne().catch(function(u) {
      console.warn("Warning: An unhandled error was caught from submitForm()", u);
    });
  }), Ie = {
    resetForm: $,
    validateForm: O,
    validateField: pe,
    setErrors: he,
    setFieldError: z,
    setFieldTouched: G,
    setFieldValue: j,
    setStatus: ge,
    setSubmitting: Te,
    setTouched: me,
    setValues: Ee,
    setFormikState: Se,
    submitForm: ne
  }, He = _(function() {
    return V(h.values, Ie);
  }), We = _(function(r) {
    r && r.preventDefault && b(r.preventDefault) && r.preventDefault(), r && r.stopPropagation && b(r.stopPropagation) && r.stopPropagation(), $();
  }), je = F(function(r) {
    return {
      value: R(h.values, r),
      error: R(h.errors, r),
      touched: !!R(h.touched, r),
      initialValue: R(g.current, r),
      initialTouched: !!R(C.current, r),
      initialError: R(w.current, r)
    };
  }, [h.errors, h.touched, h.values]), Ge = F(function(r) {
    return {
      setValue: function(u, s) {
        return j(r, u, s);
      },
      setTouched: function(u, s) {
        return G(r, u, s);
      },
      setError: function(u) {
        return z(r, u);
      }
    };
  }, [j, G, z]), Ye = F(function(r) {
    var o = J(r), u = o ? r.name : r, s = R(h.values, u), f = {
      name: u,
      value: s,
      onChange: ee,
      onBlur: re
    };
    if (o) {
      var v = r.type, S = r.value, L = r.as, ie = r.multiple;
      v === "checkbox" ? S === void 0 ? f.checked = !!s : (f.checked = !!(Array.isArray(s) && ~s.indexOf(S)), f.value = S) : v === "radio" ? (f.checked = s === S, f.value = S) : L === "select" && ie && (f.value = f.value || [], f.multiple = !0);
    }
    return f;
  }, [re, ee, h.values]), te = Ve(function() {
    return !P(g.current, h.values);
  }, [g.current, h.values]), $e = Ve(function() {
    return typeof p < "u" ? te ? h.errors && Object.keys(h.errors).length === 0 : p !== !1 && b(p) ? p(d) : p : h.errors && Object.keys(h.errors).length === 0;
  }, [p, te, h.errors, d]), Ke = E({}, h, {
    initialValues: g.current,
    initialErrors: w.current,
    initialTouched: C.current,
    initialStatus: k.current,
    handleBlur: re,
    handleChange: ee,
    handleReset: We,
    handleSubmit: Pe,
    resetForm: $,
    setErrors: he,
    setFormikState: Se,
    setFieldTouched: G,
    setFieldValue: j,
    setFieldError: z,
    setStatus: ge,
    setSubmitting: Te,
    setTouched: me,
    setValues: Ee,
    submitForm: ne,
    validateForm: O,
    validateField: pe,
    isValid: $e,
    dirty: te,
    unregisterField: Be,
    registerField: Ue,
    getFieldProps: Ye,
    getFieldMeta: je,
    getFieldHelpers: Ge,
    validateOnBlur: i,
    validateOnChange: a,
    validateOnMount: c
  });
  return Ke;
}
function br(e) {
  var n = dr(e), a = e.component, t = e.children, i = e.render, l = e.innerRef;
  return Ze(l, function() {
    return n;
  }), process.env.NODE_ENV !== "production" && D(function() {
    e.render && (process.env.NODE_ENV !== "production" ? I(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : I(!1));
  }, []), H(or, {
    value: n
  }, a ? H(a, n) : i ? i(n) : t ? b(t) ? t(n) : Le(t) ? null : we.only(t) : null);
}
function Oe(e) {
  var n = e.htmlContent, a = e.documentationAnchorLink, t = e.handlerName;
  console.warn("Warning: Formik called `" + t + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + n + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + a + `
  `);
}
function cr(e) {
  var n = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return W(n, e.path, e.message);
    for (var i = e.inner, a = Array.isArray(i), t = 0, i = a ? i : i[Symbol.iterator](); ; ) {
      var l;
      if (a) {
        if (t >= i.length)
          break;
        l = i[t++];
      } else {
        if (t = i.next(), t.done)
          break;
        l = t.value;
      }
      var c = l;
      R(n, c.path) || (n = W(n, c.path, c.message));
    }
  }
  return n;
}
function fr(e, n, a, t) {
  a === void 0 && (a = !1);
  var i = de(e);
  return n[a ? "validateSync" : "validate"](i, {
    abortEarly: !1,
    context: t || i
  });
}
function de(e) {
  var n = Array.isArray(e) ? [] : {};
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var t = String(a);
      Array.isArray(e[t]) === !0 ? n[t] = e[t].map(function(i) {
        return Array.isArray(i) === !0 || Ae(i) ? de(i) : i !== "" ? i : void 0;
      }) : Ae(e[t]) ? n[t] = de(e[t]) : n[t] = e[t] !== "" ? e[t] : void 0;
    }
  return n;
}
function vr(e, n, a) {
  var t = e.slice();
  return n.forEach(function(l, c) {
    if (typeof t[c] > "u") {
      var p = a.clone !== !1, y = p && a.isMergeableObject(l);
      t[c] = y ? le(Array.isArray(l) ? [] : {}, l, a) : l;
    } else
      a.isMergeableObject(l) ? t[c] = le(e[c], l, a) : e.indexOf(l) === -1 && t.push(l);
  }), t;
}
function pr(e) {
  return Array.from(e).filter(function(n) {
    return n.selected;
  }).map(function(n) {
    return n.value;
  });
}
function mr(e, n, a) {
  if (typeof e == "boolean")
    return !!n;
  var t = [], i = !1, l = -1;
  if (Array.isArray(e))
    t = e, l = e.indexOf(a), i = l >= 0;
  else if (!a || a == "true" || a == "false")
    return !!n;
  return n && a && !i ? t.concat(a) : i ? t.slice(0, l).concat(t.slice(l + 1)) : t;
}
var hr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? rr : D;
function _(e) {
  var n = U(e);
  return hr(function() {
    n.current = e;
  }), F(function() {
    for (var a = arguments.length, t = new Array(a), i = 0; i < a; i++)
      t[i] = arguments[i];
    return n.current.apply(void 0, t);
  }, []);
}
function Ar(e) {
  var n = e.validate, a = e.name, t = e.render, i = e.children, l = e.as, c = e.component, p = e.className, y = Y(e, ["validate", "name", "render", "children", "as", "component", "className"]), T = Ce(), V = Y(T, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && D(function() {
    t && (process.env.NODE_ENV !== "production" ? I(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + a + '" render={({field, form}) => ...} /> with <Field name="' + a + '">{({field, form, meta}) => ...}</Field>') : I(!1)), l && i && b(i) && (process.env.NODE_ENV !== "production" ? I(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : I(!1)), c && i && b(i) && (process.env.NODE_ENV !== "production" ? I(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : I(!1)), t && i && !Le(i) && (process.env.NODE_ENV !== "production" ? I(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : I(!1));
  }, []);
  var M = V.registerField, d = V.unregisterField;
  D(function() {
    return M(a, {
      validate: n
    }), function() {
      d(a);
    };
  }, [M, d, a, n]);
  var g = V.getFieldProps(E({
    name: a
  }, y)), w = V.getFieldMeta(a), C = {
    field: g,
    form: V
  };
  if (t)
    return t(E({}, C, {
      meta: w
    }));
  if (b(i))
    return i(E({}, C, {
      meta: w
    }));
  if (c) {
    if (typeof c == "string") {
      var k = y.innerRef, A = Y(y, ["innerRef"]);
      return H(c, E({
        ref: k
      }, g, A, {
        className: p
      }), i);
    }
    return H(c, E({
      field: g,
      form: V
    }, y, {
      className: p
    }), i);
  }
  var N = l || "input";
  if (typeof N == "string") {
    var Q = y.innerRef, X = Y(y, ["innerRef"]);
    return H(N, E({
      ref: Q
    }, g, X, {
      className: p
    }), i);
  }
  return H(N, E({}, g, y, {
    className: p
  }), i);
}
var Er = /* @__PURE__ */ Je(function(e, n) {
  var a = e.action, t = Y(e, ["action"]), i = a ?? "#", l = Ce(), c = l.handleReset, p = l.handleSubmit;
  return H("form", E({
    onSubmit: p,
    ref: n,
    onReset: c,
    action: i
  }, t));
});
Er.displayName = "Form";
export {
  Er as F,
  br as a,
  Ar as b,
  Ce as u
};
